import React, { useContext, useEffect } from 'react';
import OrderFunctions from '../../../../MyFunctions/OrderFunctions';
import MyDateTime from '../../../MySections/TimeSections/MyDateTime';
import OrderStatuselect from './OrderStatuselect';
import { UserContext } from '../../../MyContexts/Users_Context';

const ListOrdersTable = (props) => {
    const [user, setUser] = useContext(UserContext);

    useEffect(() => {
        props.orderBythis("dateToDeliver", "ord");
    }, [])

    const orderBythis = (byWhat, ordUserOrBuiss) => {
        props.orderBythis(byWhat, ordUserOrBuiss);
    }
    const rowCellClick = (ordId) => {
        props.rowCellClick(ordId);
    }

    const setNewStatus = (orderId, statBack) => {
        console.log('new stat');
        props.setNewStatus(orderId, statBack);
    }

    return (
        <div className="row lstOrderTbls">
            <div className="col-xl-12">
                <div className="table-responsive ms-panel-body">
                    <table className="table table-hover thead-primary">
                        <thead>
                            <tr>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("orderNUM", "ord")}>מספר הזמנה</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("buissName", "buiss")}>שם העסק</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("firstName", "theUser")}>שם הלקוח</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("deliveryAddress.street", "ord")}>יעד</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("orderStatus", "ord")}>סטטוס הזמנה</th>
                                <th scope="col" className={"pointing"} onClick={() => orderBythis("dateToDeliver", "ord")}>מועד מסירה</th>
                                <th scope="col">תזמון</th>
                                <th scope="col">מחיר</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                props.theList.map((item, i) => {
                                    let showme = (item.paymentStatus !== "ממתין לחיוב") ?
                                        true :
                                        (user.permiss === "admin") ? true : false;
                                    return (

                                        <tr key={item._id} className={`${showme ? "" : "hideMe"} pointing ${item.paymentStatus === "ממתין לחיוב" ? "tempoOrdRow" : ""}`}
                                            itmid={item._id}>
                                            <th scope="row" onClick={() => rowCellClick(item._id)}>{item.orderNUM}</th>
                                            <td onClick={() => rowCellClick(item._id)}>{"נפוליאון"}</td>
                                            <td onClick={() => rowCellClick(item._id)}> {item.user.firstName}  {item.user.lastName}</td>

                                            <td onClick={() => rowCellClick(item._id)}>
                                                {/* {(item.OrderType == "Deliver") ? */}
                                                {item.deliveryAddress ? `${item.deliveryAddress.street} ${item.deliveryAddress.num} ${item.deliveryAddress.city}`
                                                    :
                                                    "TAKE"}
                                            </td>
                                            <td className={"statusCell pointing"} >
                                                <OrderStatuselect orderStatus={item.orderStatus}
                                                    setOrderStatus={(statBack) => setNewStatus(item._id, statBack)}
                                                />
                                            </td>
                                            <td onClick={() => rowCellClick(item._id)}>{MyDateTime.getDateAndTime(item.dateToDeliver)}</td>

                                            <td className={"timerTd"} onClick={() => rowCellClick(item._id)} id={i + "_Count"}>
                                                <div id={i + "_Cnt"}>
                                                    <br />
                                                </div>
                                            </td>
                                            {/* <td>{item.deliverytime}</td> */}
                                            <td onClick={() => rowCellClick(item._id)}> {item.totalPrice} ₪</td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ListOrdersTable;